import { render, staticRenderFns } from "./WorkflowInvocationsCount.vue?vue&type=template&id=71091d2c"
import script from "./WorkflowInvocationsCount.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowInvocationsCount.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports